"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OrdersContextProvider = exports.useOrders = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _agent = require("@deosite/agent");
var _useProductsBySkus = require("./useProductsBySkus");
var _AccountProvider = require("./AccountProvider");
var _TokenProvider = require("../common/TokenProvider");
var _CartProvider = require("./CartProvider");
var _LanguageProvider = require("../common/LanguageProvider");
var _mapOrder = _interopRequireDefault(require("@deosite/helpers/mapOrder"));
var _mapAddressNew = _interopRequireDefault(require("@deosite/helpers/mapAddressNew"));
var _createSearchUrl = require("@deosite/helpers/createSearchUrl");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var OrdersContext = /*#__PURE__*/_react["default"].createContext();
OrdersContext.IN_PROGRESS = "inProgress";
OrdersContext.COMPLETE = "complete";
var OrdersContextProvider = function OrdersContextProvider(props) {
  var children = props.children;
  var _useState = (0, _react.useState)({
      customerId: null,
      mostRecentOrder: null
    }),
    ordersState = _useState[0],
    setOrdersState = _useState[1];
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useCart = (0, _CartProvider.useCart)(),
    handleResponseErrors = _useCart.handleResponseErrors;
  var _useAccount = (0, _AccountProvider.useAccount)(),
    accountData = _useAccount.accountData;
  var getOrders = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(ordersType, pageSize, currentPage) {
      var isMostRecentOrder,
        _sessionStorage,
        ordersInStorage,
        id,
        ordersFilters,
        ordersRequestParams,
        orderList,
        ordersSkus,
        uniqueSkus,
        products,
        _sessionStorage2,
        idAndOrders,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isMostRecentOrder = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
              if (!(typeof window !== "undefined")) {
                _context.next = 40;
                break;
              }
              _context.prev = 2;
              ordersInStorage = (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.getItem("mostRecentOrderAndCustomerId");
              if (!(ordersInStorage && isMostRecentOrder)) {
                _context.next = 7;
                break;
              }
              setOrdersState(JSON.parse(ordersInStorage));
              return _context.abrupt("return");
            case 7:
              id = ordersState.customerId;
              if (!id) {
                id = accountData.id;
              }
              _context.t0 = ordersType;
              _context.next = _context.t0 === OrdersContext.IN_PROGRESS ? 12 : _context.t0 === OrdersContext.COMPLETE ? 14 : 16;
              break;
            case 12:
              ordersFilters = {
                field: "state",
                condition_type: "nin",
                value: ["complete", "cancelled"],
                connector: _createSearchUrl.CONNECTORS.AND
              };
              return _context.abrupt("break", 17);
            case 14:
              ordersFilters = {
                field: "state",
                condition_type: "in",
                value: ["complete", "cancelled"],
                connector: _createSearchUrl.CONNECTORS.AND
              };
              return _context.abrupt("break", 17);
            case 16:
              ordersFilters = null;
            case 17:
              ordersRequestParams = ordersType ? [ordersFilters, {
                sort_field: "created_at",
                direction: "desc",
                connector: _createSearchUrl.CONNECTORS.AND
              }, {
                pageSize: pageSize
              }, {
                currentPage: currentPage
              }] : [{
                sort_field: "created_at",
                direction: "desc",
                connector: _createSearchUrl.CONNECTORS.AND
              }, {
                pageSize: pageSize
              }, {
                currentPage: currentPage
              }];
              _context.next = 20;
              return _agent.requests.get((0, _createSearchUrl.createSearchUrl)(global.__appConfig__.orders, ordersRequestParams), false, token, language);
            case 20:
              orderList = _context.sent;
              orderList === null || orderList === void 0 ? void 0 : orderList.items.map(function (order) {
                var _order$extension_attr, _order$extension_attr2, _order$extension_attr3;
                order.skus = order.items.map(function (product) {
                  return product.sku.toString();
                });
                order.products = order.items;
                var shippingOrder = order === null || order === void 0 ? void 0 : (_order$extension_attr = order.extension_attributes) === null || _order$extension_attr === void 0 ? void 0 : (_order$extension_attr2 = _order$extension_attr.shipping_assignments) === null || _order$extension_attr2 === void 0 ? void 0 : (_order$extension_attr3 = _order$extension_attr2[0]) === null || _order$extension_attr3 === void 0 ? void 0 : _order$extension_attr3.shipping;
                order.billingAddress = (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, order.billing_address), {}, {
                  country: [{
                    id: order.billing_address.country_id
                  }]
                }));
                order.shippingAddress = shippingOrder !== null && shippingOrder !== void 0 && shippingOrder.address ? (0, _mapAddressNew["default"])(_objectSpread(_objectSpread({}, shippingOrder.address), {}, {
                  country: [{
                    id: shippingOrder.address.country_id
                  }]
                })) : null;
              });
              ordersSkus = orderList.items.map(function (order) {
                return order.skus;
              }).toString();
              uniqueSkus = ordersSkus ? ordersSkus.split(",").reduce(function (uniqueSku, sku) {
                return uniqueSku.includes(sku) ? uniqueSku : [].concat((0, _toConsumableArray2["default"])(uniqueSku), [sku]);
              }, []) : null;
              if (!uniqueSkus) {
                _context.next = 30;
                break;
              }
              _context.next = 27;
              return (0, _useProductsBySkus.fetcher)({
                skus: uniqueSkus,
                pageSize: 10,
                language: language
              });
            case 27:
              _context.t1 = _context.sent;
              _context.next = 31;
              break;
            case 30:
              _context.t1 = [];
            case 31:
              products = _context.t1;
              if (isMostRecentOrder) {
                idAndOrders = {
                  customerId: id,
                  mostRecentOrder: orderList ? orderList === null || orderList === void 0 ? void 0 : orderList.items.map(function (order) {
                    return (0, _mapOrder["default"])(order, products.filter(function (product) {
                      return order.skus.includes(product.sku);
                    }));
                  }) : []
                };
                (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.setItem("mostRecentOrderAndCustomerId", JSON.stringify(idAndOrders));
                setOrdersState(idAndOrders);
              }
              return _context.abrupt("return", {
                orders: orderList ? orderList === null || orderList === void 0 ? void 0 : orderList.items.map(function (order) {
                  return (0, _mapOrder["default"])(order, products.filter(function (product) {
                    return order.skus.includes(product.sku);
                  }));
                }) : [],
                totalCount: orderList.total_count
              });
            case 36:
              _context.prev = 36;
              _context.t2 = _context["catch"](2);
              console.log("There was an error while fetching customer's order list");
              handleResponseErrors(_context.t2);
            case 40:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 36]]);
    }));
    return function getOrders(_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
  var removeUserOrders = function removeUserOrders() {
    var _sessionStorage3, _sessionStorage4;
    (_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : _sessionStorage3.removeItem("mostRecentOrderAndCustomerId");
    (_sessionStorage4 = sessionStorage) === null || _sessionStorage4 === void 0 ? void 0 : _sessionStorage4.removeItem("ordersList");
    setOrdersState({
      customerId: null,
      mostRecentOrder: null
    });
  };
  var getFullOrdersList = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(currentPage, ordersType, pageSize) {
      var orders;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getOrders(ordersType, pageSize !== null && pageSize !== void 0 ? pageSize : global.__appConfig__.ordersPageSize, currentPage, false);
            case 2:
              orders = _context2.sent;
              return _context2.abrupt("return", orders);
            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function getFullOrdersList(_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }();
  return __jsx(OrdersContext.Provider, {
    value: {
      getOrders: getOrders,
      mostRecentOrder: ordersState.mostRecentOrder,
      removeUserOrders: removeUserOrders,
      getFullOrdersList: getFullOrdersList,
      ordersTypes: {
        inProgress: OrdersContext.IN_PROGRESS,
        complete: OrdersContext.COMPLETE
      }
    }
  }, children);
};
exports.OrdersContextProvider = OrdersContextProvider;
var useOrders = function useOrders() {
  var loadOrders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _useContext = (0, _react.useContext)(OrdersContext),
    getOrders = _useContext.getOrders,
    mostRecentOrder = _useContext.mostRecentOrder,
    removeUserOrders = _useContext.removeUserOrders,
    getFullOrdersList = _useContext.getFullOrdersList,
    ordersTypes = _useContext.ordersTypes;
  (0, _react.useEffect)(function () {
    if (loadOrders && !mostRecentOrder) {
      getOrders(null, 1, 0, true);
    }
  }, [loadOrders]);
  return {
    getOrders: getOrders,
    mostRecentOrder: mostRecentOrder,
    removeUserOrders: removeUserOrders,
    getFullOrdersList: getFullOrdersList,
    ordersTypes: ordersTypes
  };
};
exports.useOrders = useOrders;
var _default = OrdersContextProvider;
exports["default"] = _default;